import GoodRecommendations from './GoodRecommendations'

export default GoodRecommendations
